/* tslint:disable:max-line-length */
import {FuseNavigationItem} from '@fuse/components/navigation';

const items: FuseNavigationItem[] = [
  // {
  //     id: 'dashboards',
  //     title: 'Dashboards',
  //     subtitle: 'Unique dashboard designs',
  //     type: 'group',
  //     icon: 'heroicons_outline:home',
  //     children: [
  //         {
  //             id: 'dashboards.analytics',
  //             title: 'Analytics',
  //             type: 'basic',
  //             icon: 'heroicons_outline:chart-pie',
  //             link: '/dashboards/analytics'
  //         },
  //         {
  //             id: 'dashboards.finance',
  //             title: 'Finance',
  //             type: 'basic',
  //             icon: 'heroicons_outline:cash',
  //             link: '/dashboards/finance'
  //         }
  //     ]
  // },
  // {
  //     id: 'apps',
  //     title: 'Apps',
  //     type: 'group',
  //     children: [
  //         {
  //             id: 'apps.ecommerce',
  //             title: 'ECommerce',
  //             type: 'collapsable',
  //             icon: 'heroicons_outline:shopping-cart',
  //             children: [
  //                 {
  //                     id: 'apps.ecommerce.pos',
  //                     title: 'POS',
  //                     type: 'basic',
  //                     link: 'ecommerce/pos'
  //                 }
  //             ]
  //         }
  //     ]
  // },
];

export const defaultNavigation: FuseNavigationItem[] = items;
export const compactNavigation: FuseNavigationItem[] = items;
export const futuristicNavigation: FuseNavigationItem[] = items;
export const horizontalNavigation: FuseNavigationItem[] = items;
